/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_Nudge_DismissInputs */



/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Install_Nudge_DismissInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const install_nudge_dismiss = /** @type {((inputs?: Install_Nudge_DismissInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Nudge_DismissInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schließen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("关闭")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("關閉")
	if (locale === "ko") return /** @type {LocalizedString} */ ("닫기")
	return /** @type {LocalizedString} */ ("Dismiss")
});